import { defineComponent as _defineComponent } from 'vue'
import DashboardPools from "@/components/dashboard/DashboardPools.vue";
import TotalSupply from "@/components/dashboard/TotalSupply.vue";
import LatestBlock from "@/components/dashboard/LatestBlock.vue";
import TokenomicsDashboard from "@/components/dashboard/TokenomicsDashboard.vue";
import ActiveValidators from "@/components/dashboard/ActiveValidators.vue";
import AverageBlockTime from "@/components/dashboard/AverageBlockTime.vue";
import CirculatingSupply from "@/components/dashboard/CirculatingSupply.vue";
import DashboardInflation from "@/components/dashboard/DashboardInflation.vue";
import StakingApr from "@/components/dashboard/StakingApr.vue";
import {useConfigurationStore} from "@/store/configuration.store";
import {computed} from "vue";
import InfoBanner from "@/components/dashboard/InfoBanner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props, { expose: __expose }) {
  __expose();

const configConfigured = computed(() => {
  return useConfigurationStore().getConfigName;
});

const circulatingSupplyVisible = computed(() => {
  return useConfigurationStore().config.circulatingSupplyVisible;
});

const __returned__ = { configConfigured, circulatingSupplyVisible, DashboardPools, TotalSupply, LatestBlock, TokenomicsDashboard, ActiveValidators, AverageBlockTime, CirculatingSupply, DashboardInflation, StakingApr, InfoBanner }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})